import { render } from "./DropdownWidget.vue?vue&type=template&id=18b3ff3f&scoped=true"
import script from "./DropdownWidget.vue?vue&type=script&lang=js"
export * from "./DropdownWidget.vue?vue&type=script&lang=js"

import "./DropdownWidget.vue?vue&type=style&index=0&id=18b3ff3f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lv2353\\workspace\\5160-ited\\collection-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b3ff3f"]])

export default __exports__